

//Notes - https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8 
// https://theinfogrid.com/tech/developers/angular/building-http-interceptor-angular-5/


import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { retry, catchError, finalize, map } from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import { Router } from '@angular/router';
// import 'rxjs/add/observable/throw'
// import 'rxjs/add/operator/catch';
//import swal from 'sweetalert2';
//const swal = require('sweetalert');

var requestCount = 0;
var finalCount = 0;
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoaderService } from '../services/Common/loader.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private loaderService: LoaderService, private router: Router,) { }
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.isLoading.next(true);
    requestCount = requestCount + 1;
    return next.handle(request)
      .pipe(
        // map((event: HttpEvent<any>) => {
        //   // Handle successful response here
        //   if (event instanceof HttpResponse) {
        //     // Check if the response is a Blob (binary data like PDF)
        //     if (event.body instanceof Blob) {
        //       debugger
               
        //     }
        //   }
        //   return event;
        // }),
        retry(1),
        catchError((error) => {
          let errorMessage = '';
          console.log("request", request);
          // alert('intercept error');
          //intercept the respons error and displace it to the console

          console.log("Error Occurred");
          let requestMethod = request.method
          if (requestMethod != "GET") {
            // alert('get');


            if (error.error instanceof ErrorEvent) {
              // alert('client');
              // client-side error
              errorMessage = `Error: ${error.error.message}`;
            } else {
              // server-side error
              //console.log(error.error);
              let errorDetails = error.error;
              if (error.status == "400") {
                // errorDetails[0].DeveloperMessage =''
                if (errorDetails[0].DeveloperMessage != null) {
                  errorMessage = errorDetails[0].DeveloperMessage;
                  if(errorDetails[0].Code=='5005'){
                    localStorage.removeItem('MerchantLogo');
                    localStorage.removeItem('logodetails');
                    localStorage.removeItem('SettingDetails');
                    localStorage.removeItem('uniqueId');
                    localStorage.removeItem("MerchantKeyId");
                    localStorage.removeItem("VirtualPOSToken"); 
                    this.router.navigate(['/logins'])
                  }
                  if(errorDetails[0].Code=='0008'){
                    localStorage.removeItem('MerchantLogo');
                    localStorage.removeItem('logodetails');
                    localStorage.removeItem('SettingDetails');
                    localStorage.removeItem('uniqueId');
                    localStorage.removeItem("MerchantKeyId");
                    localStorage.removeItem("VirtualPOSToken")
                    this.router.navigate(['/logins'])
                  } 
                 // swal.fire("", errorMessage.toString(), "warning");

                }
                else {
                  errorMessage = `Error Code: 400 \nMessage: Bad Request - Contact to System Admin`;
                 // swal.fire("Error", errorMessage.toString(), "error");
                }
              }

              else if (error.status == "500") {
                errorMessage = `Error Code: 500 \nMessage: Internal Error - Contact to System Admin`;
               // swal.fire("Error", errorMessage.toString(), "error");
              }
              else {

                errorMessage = `Error Code: ${error.status}\nMessage: Contact to System Admin`;
//                swal.fire("Error", errorMessage.toString(), "error");


              }
              // errorMessage = 'Erro Code: '+ errorDetails.Code + "Message :" + errorDetails.DeveloperMessage;
            }
            // swal.fire("Error", errorMessage.toString(), "error");
          }
          console.log(errorMessage);
          return throwError(errorMessage);
        })
      ).pipe(finalize(() => {
        finalCount = finalCount + 1;
        if (requestCount == finalCount) {
          this.loaderService.isLoading.next(false);
          requestCount = 0;
          finalCount = 0;

        }
      }))

  }

}
